import { render, staticRenderFns } from "./DarkModeSwitch.vue?vue&type=template&id=3f2f2c47&scoped=true&"
import script from "./DarkModeSwitch.vue?vue&type=script&lang=ts&"
export * from "./DarkModeSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./DarkModeSwitch.vue?vue&type=style&index=0&id=3f2f2c47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2f2c47",
  null
  
)

export default component.exports